import { mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			myrules: {
				required: value => !!value || 'Required.',
				arrayRequired: value => value.length > 0 || 'Required',
				alphanumeric: value =>
					/^[a-z0-9]+$/i.test(value) ||
					'Only aphanumeric values allowed',
				email: value =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
						value
					) || 'Email not valid.',
				spaces: value =>
					(value || '').indexOf(' ') < 0 || 'No spaces are allowed',
			},
		};
	},
	computed: {
		...mapGetters([
			'socialCredits',
			'socialCreditLoading',
			'socialCreditNotification',
			'totalPosts',
			'suggestedUsers',
			'notifications',
			'userRequests',
			'searchedUsers',
			'searchedGroups',
			'searchedEvents',
			'searchedFeaturedUsers',
			'searchLoading',
			'reload',
			'postEvents',
			'userConnects',
			'authUser',
			'authLoading',
			'authNotification',
			'article',
			'articles',
			'joinedGroups',
			'featuredArticles',
			'articleLoading',
			'articleNotification',
			'challenge',
			'challenges',
			'featuredChallenges',
			'challengeLoading',
			'challengeNotification',
			'ad',
			'ads',
			'featuredAds',
			'adLoading',
			'adNotification',
			'singleNews',
			'news',
			'featuredNews',
			'newsLoading',
			'newsNotification',
			'post',
			'posts',
			'postLoading',
			'postNotification',
			'chat',
			'chats',
			'chatLoading',
			'chatNotification',
			'fusers',
			'fusers',
			'featuredUser',
			'userLoading',
			'userNotification',
			'socialLinks',
			'socialLinkLoading',
			'socialLinkNotification',
			'musicVideos',
			'musicVideoLoading',
			'musicVideoNotification',
			'musicAudios',
			'musicAudioLoading',
			'musicAudioNotification',
			'musicReferences',
			'musicReferenceLoading',
			'musicReferenceNotification',
			'musicRooms',
			'featuredMusicRooms',
			'musicRoomLoading',
			'musicRoomNotification',
			'searchQuery',
			'socialSocialUser',
			'socialSocialUsers',
			'socialSocialUserLoading',
			'socialSocialUserNotification',
			'requestedTo',
			'requestedBy',
			'group',
			'groups',
			'groupLoading',
			'groupNotification',
			'groupPosts',
			'subscription',
			'subscriptions',
			'subscriptionLoading',
			'subscriptionNotification',
			'isVerificiationPending',
		]),
	},
	methods: {
		...mapActions([
			'validateEmail',
			'validateUsername',
			'getSocialCredits',
			'addSocialCredit',
			'editSocialCredit',
			'deleteSocialCredit',
			'sendVerification',
			'readNotifications',
			'isVerificationRequested',
			'getNotifications',
			'getSearchedData',
			'requestJoinGroup',
			'cancelJoinGroup',
			'acceptGroupRequest',
			'rejectGroupRequest',
			'getUserRequests',
			'addGroupPostLike',
			'setUserRequests',
			'getEvents',
			'registers',
			'getAuthUser',
			'login',
			'forgetPassword',
			'logout',
			'updateProfile',
			'updateGroupImage',
			'getArticle',
			'getArticles',
			'getFeaturedArticles',
			'getChallenge',
			'getChallenges',
			'getFeaturedChallenges',
			'getAd',
			'getAds',
			'getFeaturedAds',
			'getSingleNews',
			'getNews',
			'getFeaturedNews',
			'getPost',
			'getPosts',
			'getMorePosts',
			'addPost',
			'addPostLike',
			'getSuggestedUsers',
			'addPostComment',
			'getUser',
			'getUsers',
			'deleteChat',
			'getTotalPosts',
			'getFeaturedUsers',
			'getConnects',
			'getSocialLinks',
			'addSocialLink',
			'editSocialLink',
			'deleteSocialLink',
			'getMusicVideos',
			'addMusicVideo',
			'editMusicVideo',
			'deleteMusicVideo',
			'getMusicAudios',
			'addMusicAudio',
			'editMusicAudio',
			'deleteMusicAudio',
			'getMusicReferences',
			'addMusicReference',
			'editMusicReference',
			'deleteMusicReference',
			'getMusicRooms',
			'getFeaturedMusicRooms',
			'addMusicRoom',
			'editMusicRoom',
			'deleteMusicRoom',
			'getChat',
			'getChats',
			'sendMessage',
			'removeChatMember',
			'getSocialUser',
			'getSocialUsers',
			'sendConnectRequest',
			'disconnect',
			'getRequestSent',
			'getRequestRecieved',
			'cancelRequest',
			'acceptRequest',
			'rejectRequest',
			'getGroup',
			'getGroups',
			'resetGroupsSearch',
			'addGroup',
			'editGroup',
			'getJoinedGroups',
			'leaveGroup',
			'deleteGroup',
			'addGroupPost',
			'getGroupPosts',
			'addGroupPostComment',
			'getSubscription',
			'getSubscriptions',
			'createSubscription',
			'unSubscribe',
			'reSubscription',
		]),
		getLoggedUser() {
			const loggedUser =
				this.authUser != null
					? this.authUser
					: JSON.parse(localStorage.getItem('authUser'));
			return loggedUser;
		},
	},
};
